import { render, staticRenderFns } from "./NoDesign.vue?vue&type=template&id=0d276e26&"
import script from "./NoDesign.vue?vue&type=script&lang=js&"
export * from "./NoDesign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports